module.exports = __webpack_public_path__ + "static/Jack_Lambert_Resume-cea7384f097aa957cc24abc204ab8d86.pdf";